/**
 * Edited by Amine on 12/10/2021.
 */
(function () {
    'use strict';

    class ProcedurePrescriptionFormCtrl {
        constructor($q, system, prescriptionService, medicalCareService, editorManagerService, authService, $transition$, $mdDialog, moment, $scope) {
            this.q = $q;
            this.scope = $scope;
            this.prescriptionService = prescriptionService;
            this.medicalCareService = medicalCareService;
            this.editorManagerService = editorManagerService;
            this.dialog = $mdDialog;
            this.moment = moment;

            this.dateFormat = system['date_format'].js;
            this.isRoot = authService.isRootProfile();

            this.currentPatient = _.get($transition$.params('to'), 'pId');
            this.currentVisit = _.get($transition$.params('to'), 'visitId');
            this.currentPrescription = _.get($transition$.params('to'), 'prescriptionId');
            this.currentCopy = _.get($transition$.params('to'), 'copy');

            this.promise = null;
            this.prescription = {};
            this.editorOpts = {};
            this.editorConfigKey = "procedure_prescription";
            this.showFileManager = false;
            this.editorName = _.uniqueId("care-prescription-");
            this.editModel = false;
        }

        static get $inject() {
            return ["$q", "system", "prescriptionService", "medicalCareService", "editorManagerService", "authService", "$transition$", "$mdDialog", "moment", "$scope"];
        }

        $onInit() {
            let promise = null;
            this.prescriptionService.prescriptionType.next({type: 'CarePrescription'});

            this.prescriptionService.itemActive.next({id: -1, type: null});
            this.prescriptionService.itemDuplicated.next({id: -1, type: null});
            this.prescriptionService.itemEdited.next({id: this.currentPrescription, type: 'CarePrescription'});

            if (!_.isNull(this.currentCopy)) {
                this.prescriptionService.itemDuplicated.next({id: this.currentCopy, type: 'CarePrescription'});
                promise = this.prescriptionService.getCarePrescription(this.currentCopy);
            } else if (!_.isNull(this.currentPrescription)) {
                promise = this.prescriptionService.getCarePrescription(this.currentPrescription);
            } else {
                promise = this.emptyPrescription();
            }

            this.promise = promise.then(data => {
                this.prescription = _.isNull(this.currentCopy) ? data : _.chain(data)
                    .pick(data, 'details')
                    .assign({
                        visit: {id: this.currentVisit},
                        prescription_date: this.moment().format(this.dateFormat)
                    })
                    .value();

                if (_.isNull(this.currentCopy)) {
                    this.editModel = data['is_model'];

                    this.prescriptionService.prescriptionType.next({
                        type: 'CarePrescription',
                        model: this.editModel
                    })
                }
            });

            this.itemDeletedSubscription = this.prescriptionService.itemDeleted.subscribe(item => this.itemDeleted(item));
            this.itemAddedSubscription = this.prescriptionService.addProcedurePrescriptionSubject.subscribe(id => this.itemAdded(id));
            this.fileManagerSubscription = this.prescriptionService.fileManager.subscribe(next => {
                this.showFileManager = !!next;
            });

            this.scope.$on("$destroy", () => this.onDestroy())
        }

        onDestroy() {
            if (!!this.itemDeletedSubscription) this.itemDeletedSubscription.unsubscribe();
            if (!!this.itemAddedSubscription) this.itemAddedSubscription.unsubscribe();
            if (!!this.fileManagerSubscription) this.fileManagerSubscription.unsubscribe();
        }

        submit(quit) {
            return this.prescriptionService
                .saveCarePrescription(this.prescription, this.currentPatient)
                .then(data => {
                    let promise = this.q.when(data);

                    if (this.editModel) {
                        this.prescriptionService.modelAdded.next(data);
                    } else {
                        this.prescriptionService.itemAdded.next(data);

                        if (this.prescription.is_locked && !data.is_signed) {
                            promise = this.prescriptionService.sign("care-prescription", data);
                        } else if (!this.prescription.is_locked && data.is_signed) {
                            promise = this.prescriptionService.unsign("care-prescription", data, this.isRoot);
                        }
                    }

                    promise.then(data => {
                        if (quit === "list") return this.prescriptionService.listState();
                        if (quit === "back") return this.goBack();

                        if (_.isNull(this.currentPrescription)) {
                            this.prescription = data;
                            this.currentPrescription = data.id;
                            this.prescriptionService.refreshState(data);
                        } else {
                            this.prescription.is_locked = data.is_locked;
                            this.prescription.is_signed = data.is_signed;
                        }
                    });

                    return data;
                });
        }

        saveModel($event) {
            let confirm = this.dialog.mnPromptDialog()
                .title('exam_model_title')
                .event('prescription.CarePrescription.title_validation')
                .placeholder('title')
                .targetEvent($event)

            this.dialog.show(confirm)
                .then(modelData => {
                    let model = _.chain(this.prescription)
                        .pick('details')
                        .assign({title: modelData})
                        .value();

                    this.prescriptionService.saveCarePrescription(model)
                        .then(data => this.prescriptionService.modelAdded.next(data));
                });
        }

        callback(data) {
            _.forEach(data, item => {
                const itemExist = _.find(this.prescription.details, {procedure: {id: item.id}});

                if (!itemExist) this.prescription.details.push({
                    name: item.title,
                    comment: "",
                    procedure: _.pick(item, "id")
                });
            });
        }

        addEmptyDetail() {
            this.prescription.details.push({
                name: null,
                qte: 1,
                code: "",
                comment: ""
            });
        }

        signPrescription() {
            this.prescription.is_locked = true;

            return this.submit();
        }

        unlockPrescription() {
            if ((this.prescription.is_locked && this.prescription.is_signed) || this.isRoot)
                return this.prescriptionService.unsign("care-prescription", this.prescription, this.isRoot)
                    .then(data => this.prescription.is_locked = data.is_locked);
            else {
                return this.q.when(this.prescription);
            }
        }

        changeTab(shown) {
            this.isTable = shown;
            if (this.isTable) {
                this.editorManagerService.destroyTinymce(this.editorName);
            }
        }

        goBack() {
            return window.history.back();
        }

        emptyPrescription() {
            return this.q.when({
                visit: {id: this.currentVisit},
                prescription_date: this.moment().format(this.dateFormat),
                details: []
            });
        }

        itemDeleted(item) {
            if (_.isEqual(item, {id: this.currentPrescription, prescription_type: 'CarePrescription'})) {
                this.prescriptionService.listState();
            }
        }

        itemAdded(id) {
            this.promise = this.prescriptionService.getCarePrescription(id)
                .then(prescription => {
                        this.prescription.details = _.chain(this.prescription.details)
                            .concat(prescription.details)
                            .uniqWith((a, b) => {
                                if (_.isNil(a.procedure) || _.isNil(b.procedure)) return false;
                                else return a.procedure.id === b.procedure.id;
                            })
                            .value();
                    }
                );
        }

        generateCarePlan() {
            this.medicalCareService.fromPrescription(this.prescription.id)
                .then(data => {
                    this.medicalCareService.showForm(data.id);
                });
        }
    }

    module.exports = ProcedurePrescriptionFormCtrl;

})();
